module.exports = __webpack_public_path__ + "img/kategori-bg.16b28d83.png";